export function policyPlanCustomRecordTemplateReducer(state, action) {
  switch (action.type) {
    case "load":
      return {
        ...state,
        templates: action.collection,
      };
    case "delete":
      return {
        ...state,
        templates: state.templates.filter(
          (item) => parseInt(item.id) != parseInt(action.templateId)
        ),
      };
    case "showModal":
      return {
        ...state,
        showModal: true,
        currentTemplate: action.currentTemplate,
      };
    case "hideModal":
      return {
        ...state,
        showModal: false,
        currentTemplate: null,
      };
    default:
      throw new Error();
  }
}
